import React, { Component } from "react";
import Collapsible from "react-collapsible";
import { mergeStyleSets } from "office-ui-fabric-react/lib/Styling";
import Moment from "moment";

import { MomentDateFormat } from "../Vertical-Timeline/CustomFuntion";

import { Icon, Text, Link } from "office-ui-fabric-react";

import { TimelineItemDateText } from "../Vertical-Timeline/CustomFuntion";

const statusIconClass = mergeStyleSets({
  complete: [{ color: "#2ECC71", fontSize: "0.8em" }],
  open: [{ color: "gold", fontSize: "0.8em" }],
  close: [{ color: "red", fontSize: "0.8em" }],
});

class CompletedTaskTl extends Component<{}, IState> {
  constructor(props: any) {
    super(props);

    this.state = {
      isLoaded: false,
      currentDate: new Date(),
      completedItems: [],
      olderItems: [],
      currentItems: [],
      upcomingItems: [],
      allItems: [],
      documentURL: "",
    };
  }

  componentDidMount() {
    this.getAPI().then((apiRes) => {
      let api = JSON.parse(apiRes);
      this.setState(
        {
          documentURL: api.matterdetail,
        },
        () => {
          this._generateOlderItems(this.props.items);
          this._generateCurrentItems(this.props.items);
          this._generateUpcomingItems(this.props.items);
          this.setState({
            completedItems: this.props.items,
            isLoaded: true,
          });
        },
      );
    });
  }

  getAPI() {
    return new Promise((resolve) => {
      resolve(localStorage.getItem("api"));
    });
  }

  _generateOlderItems(currItem: any) {
    let tempOverdue = [];
    for (let c = 0; c < currItem.length; c++) {
      let itemDate = Moment(
        currItem[c].data.event.dueDate,
        "YYYY-MM-DD",
      ).toDate();

      if (itemDate < this.state.currentDate) {
        if (itemDate.getFullYear() === this.state.currentDate.getFullYear()) {
          if (itemDate.getMonth() != this.state.currentDate.getMonth()) {
            tempOverdue.push(currItem[c]);
          }
        } else {
          tempOverdue.push(currItem[c]);
        }
      }
    }
    this.setState({
      olderItems: tempOverdue,
    });
  }

  _generateCurrentItems(currItem: any) {
    let tempUpcoming = [];
    for (let c = 0; c < currItem.length; c++) {
      let itemDate = Moment(
        currItem[c].data.event.dueDate,
        "YYYY-MM-DD",
      ).toDate();
      if (
        itemDate.getMonth() === this.state.currentDate.getMonth() &&
        itemDate.getFullYear() === this.state.currentDate.getFullYear()
      ) {
        tempUpcoming.push(currItem[c]);
      }
    }
    this.setState({
      currentItems: tempUpcoming,
    });
  }

  _generateUpcomingItems(currItem: any) {
    let tempUpcoming = [];
    for (let c = 0; c < currItem.length; c++) {
      let itemDate = Moment(
        currItem[c].data.event.dueDate,
        "YYYY-MM-DD",
      ).toDate();
      if (itemDate > this.state.currentDate) {
        if (itemDate.getFullYear() === this.state.currentDate.getFullYear()) {
          if (itemDate.getMonth() != this.state.currentDate.getMonth()) {
            tempUpcoming.push(currItem[c]);
          }
        } else {
          tempUpcoming.push(currItem[c]);
        }
      }
    }

    this.setState({
      upcomingItems: tempUpcoming,
    });
  }

  _getStatusIcon(status: string) {
    if (status === "Open") {
      return (
        <Icon iconName="StatusCircleInner" className={statusIconClass.open} />
      );
    } else if (status === "Complete") {
      return (
        <Icon
          iconName="StatusCircleInner"
          className={statusIconClass.complete}
        />
      );
    } else {
      return (
        <Icon iconName="StatusCircleInner" className={statusIconClass.close} />
      );
    }
  }

  generateOlderItems() {
    this.state.olderItems.sort((a: any, b: any) => {
      return (
        parseInt(
          MomentDateFormat(a.data.event.dueDate).format("YYYYMMDD").toString(),
        ) -
        parseInt(
          MomentDateFormat(b.data.event.dueDate).format("YYYYMMDD").toString(),
        )
      );
    });
    return this.state.olderItems.map((items: any) => {
      return (
        <div className="ms-Grid-row">
          <div className="ms-Grid-col ms-sm4 ms-md2 ms-lg1">
            {this._getStatusIcon(items.data.event.status)}
          </div>
          <div className="ms-Grid-col ms-sm4 ms-md4 ms-lg3 task-date-label">
            <Text>{TimelineItemDateText(items.data.event.dueDate)}</Text>
          </div>
          <div className="ms-Grid-col ms-sm4 ms-md6 ms-lg8 table-data-description">
            <Collapsible
              key={items.id}
              className={"Collapsible-TimeLineItem"}
              contentOuterClassName={"Collapsible-Item"}
              trigger={items.data.event.task}
            >
              <Link
                type="submit"
                href={
                  this.state.documentURL +
                  "/Matter?matterCode=" +
                  items.data.matterCode +
                  "#/Workflow"
                }
                target="_blank"
              >
                {items.data.matterCode}
              </Link>
              <span>{" - "}</span> {items.data.description}
              <hr className="line-item" />
              {items.data.event.assignTo.length > 0 ? (
                <b className="assignToLabel">{"AssignTo: "} </b>
              ) : (
                ""
              )}
              {items.data.event.assignTo.map((assignto: any, index: any) => {
                return <i key={items.id + index}>{assignto.name}, </i>;
              })}
            </Collapsible>
          </div>
        </div>
      );
    });
  }

  generateCurrentItems() {
    this.state.currentItems.sort((a: any, b: any) => {
      return (
        parseInt(
          MomentDateFormat(a.data.event.dueDate).format("YYYYMMDD").toString(),
        ) -
        parseInt(
          MomentDateFormat(b.data.event.dueDate).format("YYYYMMDD").toString(),
        )
      );
    });
    return this.state.currentItems.map((items: any) => {
      return (
        <div className="ms-Grid-row">
          <div className="ms-Grid-col ms-sm4 ms-md2 ms-lg1">
            {this._getStatusIcon(items.data.event.status)}
            {/* {this._getStatusIcon(items.data.event.status)} */}
          </div>
          <div className="ms-Grid-col ms-sm4 ms-md4 ms-lg3 task-date-label">
            <Text>{TimelineItemDateText(items.data.event.dueDate)}</Text>
          </div>
          <div className="ms-Grid-col ms-sm4 ms-md6 ms-lg8 table-data-description">
            <Collapsible
              key={items.id}
              className={"Collapsible-TimeLineItem"}
              contentOuterClassName={"Collapsible-Item"}
              trigger={items.data.event.task}
            >
              <Link
                type="submit"
                href={
                  this.state.documentURL +
                  "/Matter?matterCode=" +
                  items.data.matterCode +
                  "#/Workflow"
                }
                target="_blank"
              >
                {items.data.matterCode}
              </Link>
              <span>{" - "}</span> {items.data.description}
              <hr className="line-item" />
              {items.data.event.assignTo.length > 0 ? (
                <b className="assignToLabel">{"AssignTo: "} </b>
              ) : (
                ""
              )}
              {items.data.event.assignTo.map((assignto: any, index: any) => {
                return <i key={items.id + index}>{assignto.name}, </i>;
              })}
            </Collapsible>
          </div>
        </div>
      );
    });
  }

  generateUpcomingItems() {
    this.state.upcomingItems.sort((a: any, b: any) => {
      return (
        parseInt(
          MomentDateFormat(a.data.event.dueDate).format("YYYYMMDD").toString(),
        ) -
        parseInt(
          MomentDateFormat(b.data.event.dueDate).format("YYYYMMDD").toString(),
        )
      );
    });
    return this.state.upcomingItems.map((items: any) => {
      return (
        <div className="ms-Grid-row">
          <div className="ms-Grid-col ms-sm4 ms-md2 ms-lg1">
            {this._getStatusIcon(items.data.event.status)}
          </div>
          <div className="ms-Grid-col ms-sm4 ms-md4 ms-lg3 task-date-label">
            <Text>{TimelineItemDateText(items.data.event.dueDate)}</Text>
          </div>
          <div className="ms-Grid-col ms-sm4 ms-md6 ms-lg8 table-data-description">
            <Collapsible
              key={items.id}
              className={"Collapsible-TimeLineItem"}
              contentOuterClassName={"Collapsible-Item"}
              trigger={items.data.event.task}
            >
              <Link
                type="submit"
                href={
                  this.state.documentURL +
                  "/Matter?matterCode=" +
                  items.data.matterCode +
                  "#/Workflow"
                }
                target="_blank"
              >
                {items.data.matterCode}
              </Link>
              <span>{" - "}</span> {items.data.description}
              <hr className="line-item" />
              {items.data.event.assignTo.length > 0 ? (
                <b className="assignToLabel">{"AssignTo: "} </b>
              ) : (
                ""
              )}
              {items.data.event.assignTo.map((assignto: any, index: any) => {
                return <i key={items.id + index}>{assignto.name}, </i>;
              })}
            </Collapsible>
          </div>
        </div>
      );
    });
  }

  generateCompletedItems() {
    return this.state.completedItems.map((items: any) => {
      return (
        <div className="ms-Grid-row">
          <div className="ms-Grid-col ms-sm4 ms-md2 ms-lg1">
            {this._getStatusIcon(items.data.event.status)}
          </div>
          <div className="ms-Grid-col ms-sm4 ms-md4 ms-lg3 task-date-label">
            <Text>{TimelineItemDateText(items.data.event.dueDate)}</Text>
          </div>
          <div className="ms-Grid-col ms-sm4 ms-md6 ms-lg8 table-data-description">
            <Collapsible
              key={items.id}
              className={"Collapsible-TimeLineItem"}
              contentOuterClassName={"Collapsible-Item"}
              trigger={items.data.event.task}
            >
              <Link
                type="submit"
                href={
                  this.state.documentURL +
                  "/Matter?matterCode=" +
                  items.data.matterCode +
                  "#/Workflow"
                }
                target="_blank"
              >
                {items.data.matterCode}
              </Link>
              <span>{" - "}</span> {items.data.description}
              <hr className="line-item" />
              {items.data.event.assignTo.length > 0 ? (
                <b className="assignToLabel">{"AssignTo: "} </b>
              ) : (
                ""
              )}
              {items.data.event.assignTo.map((assignto: any, index: any) => {
                return <i key={items.id + index}>{assignto.name}, </i>;
              })}
            </Collapsible>
          </div>
        </div>
      );
    });
  }

  public render() {
    const { isLoaded } = this.state;
    if (!isLoaded) return <div>Loading...</div>;
    else {
      const component = (
        <div className={"complete-task"}>
          {/* <Collapsible
            id="complete"
            className="upcoming-text ms-motion-slideDownIn"
            trigger={
              "Completed Task (" + this.state.completedItems.length + ")"
            }
            open={true}
            triggerDisabled={true}
            triggerOpenedClassName="upcoming-text-span"
          >
            <div className="ms-Grid task-grid" dir="ltr">
              {this.generateCompletedItems()}
            </div>
          </Collapsible> */}
          <Collapsible
            id="older"
            className="upcoming-text ms-motion-slideDownIn"
            trigger={"Older (" + this.state.olderItems.length + ")"}
            triggerOpenedClassName="upcoming-text-span"
            open={false}
          >
            <div className="ms-Grid task-grid" dir="ltr">
              {this.generateOlderItems()}
            </div>
          </Collapsible>
          <Collapsible
            id="current-month"
            className={"upcoming-text ms-motion-slideDownIn"}
            trigger={
              Moment(this.state.currentDate).format("MMMM").toString() +
              "  (" +
              this.state.currentItems.length +
              ")"
            }
            triggerOpenedClassName="upcoming-text-span"
            open={true}
          >
            <div className="ms-Grid task-grid" dir="ltr">
              {this.generateCurrentItems()}
            </div>
          </Collapsible>
          <Collapsible
            id="upcoming"
            className="upcoming-text ms-motion-slideDownIn"
            trigger={"Upcoming (" + this.state.upcomingItems.length + ")"}
            triggerOpenedClassName="upcoming-text-span"
            open={false}
          >
            <div className="ms-Grid task-grid" dir="ltr">
              {this.generateUpcomingItems()}
            </div>
          </Collapsible>
        </div>
      );

      return component;
    }
  }
}

export default CompletedTaskTl;
